var _path, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7576 21.0481H19.9274C20.3521 21.0481 20.5834 20.5519 20.3103 20.2266L18.3097 17.8437C21.4785 14.0954 21.1072 8.51026 17.47 5.2145C15.7421 3.65114 13.4519 2.85901 11.1273 3.02066C8.80269 3.18232 6.6442 4.28381 5.14928 6.0713C1.97919 9.82534 2.3583 15.4172 6.00607 18.709C7.87383 20.3249 10.2906 21.1621 12.7576 21.0481Z",
    fill: "#160404"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 10.5,
    x2: 15.5,
    y2: 10.5,
    stroke: "#F8F8F8",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 13.5,
    x2: 15.5,
    y2: 13.5,
    stroke: "#F8F8F8",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedb);
export default __webpack_public_path__ + "static/media/feedb.3c4477caff5d1ccdb843dcc8a8fa2005.svg";
export { ForwardRef as ReactComponent };